(() => {
  if (window.__elitexCartRemoveReady) return;
  window.__elitexCartRemoveReady = true;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest?.('[data-elitex-cart-remove]');
    const form = link?.closest('#CartDrawerForm[data-location="cart-drawer"]');
    const drawer = form?.closest('#CartDrawer');
    const item = link?.closest('.cart__item[data-key]');
    const wrapper = item?.querySelector('.js-qty__wrapper');
    const input = wrapper?.querySelector('.js-qty__num');

    if (!drawer || !input || input.dataset.id !== item.dataset.key || input.getAttribute('min') !== '0') return;
    if (typeof window.theme?.QtySelector !== 'function' || typeof window.theme?.CartForm !== 'function') return;

    if (wrapper.classList.contains('is-loading')) {
      event.preventDefault();
      return;
    }

    const products = form.querySelector('[data-products]');
    if (!products) return;

    const itemIndex = Array.from(products.querySelectorAll('.cart__item[data-key]')).indexOf(item);
    const restoreFocus = item.contains(document.activeElement);
    const previousQuantity = input.value;

    input.value = '0';
    input.dispatchEvent(new Event('change', { bubbles: true }));

    if (!wrapper.classList.contains('is-loading')) {
      input.value = previousQuantity;
      return;
    }

    event.preventDefault();
    item.setAttribute('aria-busy', 'true');

    if (!restoreFocus) return;

    const observer = new MutationObserver(() => {
      if (item.isConnected) return;
      observer.disconnect();
      window.clearTimeout(timeout);

      if (!drawer.classList.contains('drawer--is-open') || document.activeElement !== document.body) return;

      const items = Array.from(products.querySelectorAll('.cart__item[data-key]'));
      const nextItem = items[Math.min(itemIndex, items.length - 1)];
      const nextFocus = nextItem?.querySelector('[data-elitex-cart-remove]') || drawer.querySelector('.js-drawer-close');
      nextFocus?.focus({ preventScroll: true });
    });

    observer.observe(products, { childList: true, subtree: true });
    const timeout = window.setTimeout(() => observer.disconnect(), 20000);
  });
})();